import { Flex } from '@chakra-ui/react'
import { FiltersT } from 'modules/BioriskMpox/Epidemiology'
import LatestMedia from 'modules/BioriskMpox/common/LatestMedia'
import LatestAlerts from 'modules/BioriskMpox/LatestAnalysisNews/LatestAlerts'

const LeftSection = ({
  filters,
  disease,
}: {
  filters: FiltersT
  disease: string
}) => {
  return (
    <Flex
      flexDir={'column'}
      gap='0.5rem'
      w='350px'
      minW='300px'
      maxW='350px'
      minH={'75vh'}
    >
      <LatestAlerts
        pagination={false}
        h='90%'
        disease={disease}
        columnHeader
        selectedArea={filters.country}
      />
      <LatestMedia
        selectedArea={filters.country}
        disease={disease}
        disableTags
      />
    </Flex>
  )
}

export default LeftSection
